import { render, staticRenderFns } from "./BModals.vue?vue&type=template&id=7dbbc62c"
import script from "./BModals.vue?vue&type=script&lang=js"
export * from "./BModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports